import Image from "next/image";

export type SoftwareFeatureData = {
  title: string;
  body: string;
  subBody?: string;
  info: string[];
};

interface SoftwareFeaturesInfoProps {
  items: SoftwareFeatureData;
}

const getFeatureImageUrl = (index: number): string => {
  return `/images/software/shared/software_features_contents_info_number_${
    index + 1
  }.jpg`;
};

export function SoftwareFeaturesInfo({ items }: SoftwareFeaturesInfoProps) {
  const { title, body, subBody, info } = items;
  return (
    <section className="flex flex-col items-start gap-6 md:flex-row md:px-[100px] md:py-[10px]">
      <div className="text-gray-90 flex flex-col text-base font-400">
        <h2 className="text-3xl md:text-5xl">{title}</h2>
        <p className="pt-3 md:pt-4">{body}</p>
        {subBody && <p className="pt-3 text-coolgray-60 md:pt-4">{subBody}</p>}
        <ul className="flex list-none flex-col gap-y-3 pt-[20px] md:pt-[28px]">
          {info?.map((item, index) => (
            <li key={index} className="flex items-center gap-x-2">
              {/* 이미지로 표시 */}
              <Image
                width={24}
                height={24}
                src={getFeatureImageUrl(index)}
                alt={`Feature ${index + 1}`}
                className="h-8 w-8 object-contain"
              />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
